import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderSort } from '../../services';

export const fetchSliderSort = createAsyncThunk(
    'sliderSort/fetchSliderSort',
    async ({ id, sort }) => {
        const response = await SliderSort(id, sort)
        return response.result
    }
)

const sliderSortSlice = createSlice({
    name: 'sliderSort',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderSort.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderSort.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderSort.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderSortSlice.reducer;
